import { Injectable } from '@angular/core';
import { HttpRestService } from '@core/services/http-rest.service';
import { TimeZone } from "@core/typings/api/time-zone.typing";

@Injectable({ providedIn: 'root' })
export class TimezoneResources {

  constructor (
    private http: HttpRestService
  ) { }

  getTimezones () {
    const endpoint = 'api/lookup/timezones';

    return this.http.get<TimeZone[]>(endpoint);
  }
}
